import useRequest from '@/websdk/utils/request';

export default (function (manual) {
  const url = '/api/produce-classes';

  const { data, exec } = useRequest({
    name: 'GET_PRODUCE_CLASSES_LIST',
    url,
    manual,
  });

  return [data || [], exec];
});
